/* eslint-disable @typescript-eslint/restrict-template-expressions */
import FacebookPlan from './FacebookPlan'
import Dlg from './Dlg'
import sliderImage from '../assets/images/fb-slider-thumbs.svg'

import { type MouseEventHandler } from 'react'
import { Box, Slider, useMediaQuery } from '@mui/material'
import { styled, useTheme } from '@mui/material/styles'

interface InputDlgProps {
  name: string
  open: boolean
  handleClose: MouseEventHandler<HTMLButtonElement>
}

function valuetext (value: number) {
  return `${value} ad impressions`
}

const ImgSlider = styled(Slider)(({ theme }) => ({
  '& .MuiSlider-thumb': {
    backgroundImage: `url(${sliderImage})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center'
  }
}))

const FacebookPlanDlg: React.FC<InputDlgProps> = ({ name, open, handleClose }) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  return (
    <Dlg
      name={name}
      open={open}
      handleClose={handleClose}
      centredItems={true}
      cancelBtnText=''
      okBtnText='Done'
      bigOkBnt={true}
    >
      <Box sx={{ mt: 3, mb: 4, mx: 0, width: isMobile ? '100%' : '346px' }}>
        <FacebookPlan name='Elite' price={750}
          description='Supercharge with Animated Ads & Multiple Custom Campaigns'
          bntText=''
          planBorder={true}
        >
          <Box width='100%' sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mt: 12, mb: 3, mx: 0 }}>
            <ImgSlider
              color='secondary'
              aria-label="Plan"
              id='plan'
              defaultValue={30}
              getAriaValueText={valuetext}
              valueLabelFormat={valuetext}
              valueLabelDisplay="on"
              step={5000}
              min={10000}
              max={20000}
              sx={{ width: isMobile ? '50%' : '221px', zIndex: 1399, position: 'fixed' }}
            />
          </Box>
        </FacebookPlan>
      </Box>
    </Dlg>
  )
}

export default FacebookPlanDlg
